import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import { reduce } from "lodash";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import { decimalInvertedReportFormatter } from "../../fomatters/DecimalFormatter";
import InputSelect from "../InputSelect";
import Report from "../Report";
import SubGroup from "../SubGroup";

const currentDate = new Date();
currentDate.setMonth(currentDate.getMonth() - 1);

const today = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function Settle() {
  const [week, setWeek] = useState(today);
  const onWeekChange = useCallback((event) => setWeek(event.target.value), []);

  const [book, setBook] = useState("");
  const onBookChanged = useCallback((b) => setBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetBooks`,
  });

  const [lineType, setLineType] = useState("");
  const onLineTypeChanged = useCallback((l) => setLineType(l), []);
  const { values: lineTypes } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/LineType/GetLineTypes`,
  });

  const [office, setOffice] = useState("");
  const onOfficeChanged = useCallback((o) => setOffice(o), []);
  const { values: offices } = useDataFormatterHook({
    addEmpty: true,
    value: "officeName",
    text: "officeName",
    path: `/Player/Office_GetList`,
  });

  const [group, setGroup] = useState("");
  const onGroupChanged = useCallback((g) => setGroup(g), []);
  const { values: groups } = useDataFormatterHook({
    addEmpty: true,
    value: "groupName",
    text: "groupName",
    path: `/Player/Grouping_GetList`,
  });

  const [playerRate, setPlayerRate] = useState("");
  const onPlayerRateChanged = useCallback((pr) => setPlayerRate(pr), []);
  const { values: playerRates } = useDataFormatterHook({
    addEmpty: true,
    value: "playerRateName",
    text: "playerRateName",
    path: `/Player/PlayerRate_GetList`,
  });

  const [agentFrom, setAgentFrom] = useState("");
  const onAgentFromChange = useCallback(
    (event) => setAgentFrom(event.target.value),
    []
  );

  const [agentTo, setAgentTo] = useState("");
  const onAgenToChange = useCallback(
    (event) => setAgentTo(event.target.value),
    []
  );

  const [distributor, setDistributor] = useState("");
  const onDistributorChanged = useCallback(
    (event) => setDistributor(event.target.value),
    []
  );

  const [playerSelect, setPlayerSelect] = useState(0);
  const onPlayerSelectChange = useCallback(
    (event) => setPlayerSelect(Number(event.target.value)),
    []
  );

  const [agentType, setAgentType] = useState(0);
  const onAgentTypeChange = useCallback(
    (event) => setAgentType(Number(event.target.value)),
    []
  );

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          required
          variant="outlined"
          label="Week Of"
          type="date"
          value={week}
          size="small"
          onChange={onWeekChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Book"
          name="name"
          data={books}
          placeholder="DataFormatter"
          setSelectValue={onBookChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Group"
          name="name"
          data={groups}
          placeholder="DataFormatter"
          setSelectValue={onGroupChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Office"
          name="name"
          data={offices}
          placeholder="DataFormatter"
          setSelectValue={onOfficeChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Line Type"
          name="name"
          data={lineTypes}
          placeholder="DataFormatter"
          setSelectValue={onLineTypeChanged}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Distributor"
          type="text"
          value={distributor}
          size="small"
          onChange={onDistributorChanged}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent From"
          type="text"
          value={agentFrom}
          size="small"
          onChange={onAgentFromChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent To"
          type="text"
          value={agentTo}
          size="small"
          onChange={onAgenToChange}
          InputLabelProps={{ shrink: true }}
        />
        {/* TODO: IMPLEMENT PLAYER TYPE API */}
        <InputSelect
          variant="outlined"
          size="small"
          label="Player Type"
          name="name"
          data={playerRates}
          placeholder="DataFormatter"
          setSelectValue={onPlayerRateChanged}
          startValue={""}
        />
        <div>
          <SubGroup title="Players With">
            <FormControl component="fieldset">
              <RadioGroup
                label
                value={playerSelect}
                onChange={onPlayerSelectChange}
                row
              >
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Action"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Settled With BOW"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="All"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={3} size="small" color="primary" />}
                  label="Settled Without BOW"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
        <div>
          <SubGroup title="Agent Type">
            <FormControl component="fieldset">
              <RadioGroup
                label
                value={agentType}
                onChange={onAgentTypeChange}
                row
              >
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="All"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="XFer"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="No XFer"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
      </div>
      <Report
        title="Settle Figures Report"
        groupBy="agent"
        getUrl={() => "/Reports/Report_Settle"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          DateWeek: week,
          Book: book,
          Group: group,
          Office: office,
          LineType: lineType,
          Distributor: distributor,
          AgentFrom: agentFrom,
          AgentTo: agentTo,
          PlayerRate: playerRate,
          PlayerSelect: playerSelect,
          AgentType: agentType,
        })}
        getTotals={(data) => ({
          agent: "Agent Totals",
          player: "",
          settledFigure: reduce(
            data,
            (acc, { settledFigure }) => acc + settledFigure,
            0
          ),
          balFwd: reduce(data, (acc, { balFwd }) => acc + balFwd, 0),
          totalWeek: reduce(data, (acc, { totalWeek }) => acc + totalWeek, 0),
          total: reduce(data, (acc, { total }) => acc + total, 0),
        })}
        getGlobalTotals={(data) => ({
          agent: "Totals",
          player: "",
          settledFigure: reduce(
            data,
            (acc, { settledFigure }) => acc + settledFigure,
            0
          ),
          balFwd: reduce(data, (acc, { balFwd }) => acc + balFwd, 0),
          totalWeek: reduce(data, (acc, { totalWeek }) => acc + totalWeek, 0),
          total: reduce(data, (acc, { total }) => acc + total, 0),
        })}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="agent">
          Agent
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="player">
          Customer
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="settledFigure">
          Settled Figure
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="balFwd"
          dataFormat={decimalInvertedReportFormatter}
        >
          BalFwd
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="totalWeek"
          dataFormat={decimalInvertedReportFormatter}
        >
          Week
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="total"
          dataFormat={decimalInvertedReportFormatter}
        >
          Balance
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="totalWeek"
          dataFormat={decimalInvertedReportFormatter}
        >
          Reach Settle
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default Settle;
